import Vue from 'vue'

import Oruga from '@oruga-ui/oruga'

import '@oruga-ui/oruga/dist/oruga.css'

Vue.use(Oruga, {
    defaultIconPack: 'mdi'
});
